import _ from 'lodash'
import { SET_PROGRESS, SET_PROGRESS_MESSAGE } from './constants'

const initialState = {}

// sample state:
// const initialState = {
//     tq: {
//         percent: 0,
//         message: '',
//         value: -1,
//     },
// }

export default function reducer(state = initialState, { type, payload }) {
    switch (type) {
        // Progress for a single server has new data
        case SET_PROGRESS: {
            return {
                ...state,
                [payload.serverId]: payload.progress,
            }
        }

        // We update the message for all servers in state
        case SET_PROGRESS_MESSAGE: {
            return _.reduce(
                state,
                (result, progress, serverId) => {
                    result[serverId] = { ...progress }
                    result[serverId].message = payload || ''
                    return result
                },
                {},
            )
        }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/Backend/data/progress/reducer.js